import { render, staticRenderFns } from "./DeckCardRegular.vue?vue&type=template&id=012b3cee"
import script from "./DeckCardRegular.vue?vue&type=script&lang=js"
export * from "./DeckCardRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports